function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
  fill: "#293194",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1589 1611 c-69 -70 -1 -171 94 -139 57 20 69 109 19 148 -36 29 -78 26 -113 -9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1790 1559 c-26 -47 25 -100 69 -72 20 13 26 60 10 79 -18 22 -66 18 -79 -7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1700 1430 c-42 -42 -13 -110 47 -110 30 0 63 34 63 65 0 14 -9 34 -20 45 -11 11 -31 20 -45 20 -14 0 -34 -9 -45 -20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M924 1381 c-81 -14 -114 -54 -129 -154 -9 -58 7 -103 44 -121 14 -8 55 -17 91 -20 114 -12 120 -14 120 -45 0 -39 -17 -51 -77 -51 -45 0 -55 4 -69 25 -14 22 -24 25 -70 25 -42 0 -55 -4 -64 -19 -24 -45 -3 -103 45 -126 24 -11 65 -15 147 -15 129 0 168 13 204 68 26 38 40 135 26 173 -13 33 -61 55 -137 64 -110 12 -115 14 -115 45 0 36 12 43 69 43 35 0 48 -4 59 -21 12 -18 24 -22 66 -22 29 0 57 5 64 12 29 29 2 106 -44 127 -33 15 -173 23 -230 12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M337 1363 c-9 -16 -59 -454 -53 -468 4 -13 19 -15 68 -13 l63 3 7 54 c3 29 10 57 15 61 4 4 49 10 99 12 149 7 193 51 202 199 8 140 -22 159 -247 159 -82 0 -152 -3 -154 -7z m261 -105 c17 -17 15 -100 -4 -126 -13 -19 -24 -22 -88 -22 l-72 0 7 58 c4 31 8 67 8 80 1 21 5 22 69 22 40 0 73 -5 80 -12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1313 1358 c-14 -17 -66 -439 -57 -461 5 -13 19 -17 64 -17 33 0 61 4 64 9 10 16 59 449 53 465 -8 20 -109 23 -124 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1537 1358 c-12 -10 -21 -45 -31 -128 -34 -261 -32 -291 24 -331 23 -18 28 -18 70 -3 35 12 61 14 115 8 132 -14 169 -4 200 56 9 17 25 109 37 206 22 173 22 177 3 190 -27 20 -89 18 -107 -3 -11 -12 -21 -66 -32 -163 -19 -168 -30 -193 -91 -198 -99 -9 -109 10 -89 164 21 160 21 193 4 204 -22 14 -83 12 -103 -2z"
}));

function SvgLogo64Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo64Px);
export default __webpack_public_path__ + "static/media/logo64px.4d89057b.svg";
export { ForwardRef as ReactComponent };